import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/identities')({
  beforeLoad: ({ context, preload }) => {
    context.validateAppPermission('IDENTITIES', preload);
  },
});
